import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Shield, Factory, Sprout, Heart, ArrowRight } from 'lucide-react';

const SolutionsOverview = () => {
  const solutions = [
    {
      icon: Shield,
      title: 'AI Security & Surveillance',
      description: 'Real-time detection, clearer escalation, faster investigation.',
      path: '/solutions/security'
    },
    {
      icon: Factory,
      title: 'Industry 4.0 / Operational Intelligence',
      description: 'Digitised SOPs, inspections, and frontline workflows with traceability.',
      path: '/solutions/industry-4'
    },
    {
      icon: Sprout,
      title: 'Agriculture Intelligence',
      description: 'Practical intelligence for field operations—monitor, measure, improve.',
      path: '/solutions/agriculture'
    },
    {
      icon: Heart,
      title: 'Healthcare (WIP)',
      description: 'Coming soon.',
      path: '/solutions/healthcare',
      badge: 'WIP'
    }
  ];

  return (
    <div className="min-h-screen pt-24 pb-20">
      <div className="max-w-6xl mx-auto px-6">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <h1 className="heading-1 mb-6">Solutions</h1>
          <p className="body-large text-[var(--text-secondary)] max-w-3xl mx-auto">
            Choose the outcomes you want—security intelligence, operational visibility, or agricultural productivity. Ferntree deploys the right combination of platform modules and services to match your constraints.
          </p>
        </motion.div>

        {/* Solutions Grid */}
        <div className="grid md:grid-cols-2 gap-8 mb-16">
          {solutions.map((solution, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <Link to={solution.path}>
                <div className="product-card h-full">
                  <div className="flex items-start justify-between mb-4">
                    <solution.icon className="w-12 h-12 text-[var(--accent-primary)]" />
                    {solution.badge && (
                      <span className="text-xs px-3 py-1 bg-[var(--accent-wash)] text-[var(--accent-text)] rounded-full font-medium">
                        {solution.badge}
                      </span>
                    )}
                  </div>
                  <h3 className="heading-3 mb-3">{solution.title}</h3>
                  <p className="text-[var(--text-secondary)] mb-4">{solution.description}</p>
                  <span className="inline-flex items-center gap-2 text-[var(--accent-primary)] font-medium group-hover:gap-3 transition-all">
                    Learn more <ArrowRight className="w-4 h-4" />
                  </span>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.5 }}
          className="text-center p-12 bg-[var(--bg-section)] rounded-2xl"
        >
          <h2 className="heading-2 mb-4">Not sure where to start?</h2>
          <Link to="/contact" className="btn-primary inline-flex">
            Talk to an Expert
          </Link>
        </motion.div>
      </div>
    </div>
  );
};

export default SolutionsOverview;